import React, {useEffect, useState} from 'react';
import {Radio, Space, Spin, Empty} from 'antd';
import {logosApi, LogoItem} from '../apiCalls/logosApi';

interface LogoSelectorProps {
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
}

const IMAGE_STYLE: React.CSSProperties = {
  maxHeight: 64,
  maxWidth: 120,
  marginRight: 12,
  objectFit: 'contain',
};

const LogoSelector: React.FC<LogoSelectorProps> = ({value, onChange, disabled}) => {
  const [logos, setLogos] = useState<LogoItem[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [fetchError, setFetchError] = useState<boolean>(false);

  useEffect(() => {
    let mounted = true;

    const loadLogos = async () => {
      try {
        const data = await logosApi.getLogos();
        if (mounted) {
          setLogos(data);
          setFetchError(data.length === 0);
        }
      } catch (error) {
        console.error('Error loading logos:', error);
        if (mounted) {
          setFetchError(true);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadLogos();

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return <Spin />;
  }

  if (fetchError || logos.length === 0) {
    return <Empty description="No logos available" />;
  }

  return (
    <Radio.Group
      value={value}
      onChange={(event) => onChange?.(event.target.value)}
      disabled={disabled}
    >
      <Space wrap size={24}>
        {logos.map((logo) => (
          <Radio key={logo.id} value={logo.id}>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <img src={logo.url} alt={logo.code} style={IMAGE_STYLE} />
              <span>{logo.code}</span>
            </div>
          </Radio>
        ))}
      </Space>
    </Radio.Group>
  );
};

export default LogoSelector;
